module.exports = __webpack_public_path__ + "assets/man2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/man2.svg
// module id = 1181
// module chunks = 7